import {Component} from 'react';
import request from "superagent";
import API from "../../config/API";

// eslint-disable-next-line react/prefer-stateless-function
class JobsBase extends Component {

    componentDidMount() { // JobSearch
        request.get(`${API.getHost()}/harvest.php?path=/offices/`).then(res => {
            if (res && res.body) {
                this.setState({offices: res.body, officesLoaded: true});
            }
        });

        request.get(`${API.getHost()}/harvest.php?path=/jobs/`).then(res => {
            if (res && res.body) {
                this.setState({jobs: res.body, jobsLoaded: true});
            }
        });
    }

    /**
     * Get Roles and Functions from Custom Fields.
     *
     * @returns {{functions: [], roles: [], offices: []}}
     */
    getOfficesRolesAndFunctions = () => {
        const jobTypes = [];
        const functions = [];
        const offices = {};

        if (this.state.jobs && Object.keys(this.state.jobs).length) {
            this.state.jobs.forEach(job => {
                if (job.custom_fields && job.custom_fields.job_level) {
                    const value = job.custom_fields.job_level;
                    if (!jobTypes.includes(value)) {
                        jobTypes.push(value);
                    }
                }
                if (job.custom_fields && job.custom_fields.business_line) {
                    const value = job.custom_fields.business_line;
                    if (!functions.includes(value)) {
                        functions.push(value);
                    }
                }
            });
        }

        if(this.state.offices && Object.keys(this.state.offices).length) {

            this.state.offices.forEach(office => {
                if(!office.parent_office_external_id) {
                    offices[office.name] = [];
                }
            });
            this.state.offices.forEach(office => {
                if(office.parent_office_external_id) {
                    offices[office.parent_office_external_id].push(office.name);
                }
            });
        }

        return {jobTypes, functions, offices};
    };

    clearFilters = () => {
        const checkboxes = document.getElementsByClassName('sideBar__search--dropdownInput');

        // eslint-disable-next-line no-plusplus
        for(let i = 0; i < checkboxes.length; i++) {
            checkboxes[i].checked = false
        }

        this.setState({textFilter: '', locationFilter: [], functionFilter: [], roleFilter: [], page: 1});
    }

    /**
     * Update State for input by Key
     *
     * @param event
     * @param key
     */
    handleChange = (event, key) => {
        this.setState({[key]: event.target.value});
    };

    /**
     * Update State for input by Key
     *
     * @param value
     * @param key
     * @param removing
     */
    handleFilterChange = (value, key, removing) => {
        if(removing) {
            const newArray = [];
            this.state[key].forEach(item => {
                if(item !== value) {
                    newArray.push(item);
                }
            });
            this.setState({[key]: newArray});
        } else {
            this.setState({[key]: [...this.state[key], value]});
        }
    }
}

export default JobsBase;



// WEBPACK FOOTER //
// ./frontend/components/Jobs/JobsBase.jsx